import { createContext } from '../../utils/create-context';
export const [DatePickerProvider, useDatePickerContext] = createContext({
    hookName: 'useDatePickerContext',
    providerName: '<DatePickerProvider />',
});
